/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import StorageKeys from '../../Config/Zustand/StorageKeys.json';

/**
 * Custom checkout store
 */
export const useCheckoutStore = create(persist((set, get) => ({
  activeStep: null,
  lastValidStep: null,
  setActiveStep: (activeStep) => set({ activeStep }),
  getActiveStep: () => get().activeStep,
  setLastValidStep: (lastValidStep) => set({ lastValidStep }),
  getLastValidStep: () => get().lastValidStep,
  formData: {},
  setFormData: (values) => set({ formData: values }),
  getFormData: () => get().formData,
  updateFormDataValue: (key, value) => {
    const formDataCopy = get().formData;
    formDataCopy[key] = value;
    set({ formData: { ...get().formData, ...formDataCopy } });
  },
  getFormDataValue: (key) => get().formData[key],
}), {
  name: StorageKeys.checkoutStore,
  storage: createJSONStorage(() => sessionStorage),
}));
